
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1ybop_9",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1ybop_12",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1ybop_19",
  "drawers-container": "awsui_drawers-container_hyvsj_1ybop_24",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1ybop_35",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1ybop_56",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1ybop_61",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1ybop_99",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_1ybop_109",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1ybop_114",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_1ybop_128",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1ybop_114",
  "drawer": "awsui_drawer_hyvsj_1ybop_24",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_1ybop_159",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1ybop_168",
  "drawer-content": "awsui_drawer-content_hyvsj_1ybop_159",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_1ybop_177",
  "drawer-slider": "awsui_drawer-slider_hyvsj_1ybop_180",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1ybop_188",
  "content": "awsui_content_hyvsj_1ybop_210",
  "layout": "awsui_layout_hyvsj_1ybop_227",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1ybop_299",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1ybop_314",
  "content-type-table": "awsui_content-type-table_hyvsj_1ybop_328",
  "content-type-cards": "awsui_content-type-cards_hyvsj_1ybop_328",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1ybop_334",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_1ybop_337",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1ybop_351",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1ybop_354",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1ybop_364",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1ybop_367",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1ybop_367",
  "has-header": "awsui_has-header_hyvsj_1ybop_367",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1ybop_382",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1ybop_382",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_1ybop_402",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_1ybop_405",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1ybop_425",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1ybop_425",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1ybop_433",
  "unfocusable": "awsui_unfocusable_hyvsj_1ybop_438",
  "container": "awsui_container_hyvsj_1ybop_444",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1ybop_470",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1ybop_473",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1ybop_473",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1ybop_473",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_1ybop_473",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1ybop_478",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_1ybop_495",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1ybop_499",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1ybop_503",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1ybop_507",
  "navigation-container": "awsui_navigation-container_hyvsj_1ybop_512",
  "show-navigation": "awsui_show-navigation_hyvsj_1ybop_550",
  "animating": "awsui_animating_hyvsj_1ybop_573",
  "showButtons": "awsui_showButtons_hyvsj_1ybop_1",
  "navigation": "awsui_navigation_hyvsj_1ybop_512",
  "openNavigation": "awsui_openNavigation_hyvsj_1ybop_1",
  "animated-content": "awsui_animated-content_hyvsj_1ybop_637",
  "content-container": "awsui_content-container_hyvsj_1ybop_640",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1ybop_649",
  "notifications": "awsui_notifications_hyvsj_1ybop_655",
  "has-notification-content": "awsui_has-notification-content_hyvsj_1ybop_660",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1ybop_664",
  "high-contrast": "awsui_high-contrast_hyvsj_1ybop_669",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1ybop_683",
  "position-bottom": "awsui_position-bottom_hyvsj_1ybop_730",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1ybop_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1ybop_759",
  "position-side": "awsui_position-side_hyvsj_1ybop_772",
  "tools-container": "awsui_tools-container_hyvsj_1ybop_790",
  "tools": "awsui_tools_hyvsj_1ybop_790",
  "openTools": "awsui_openTools_hyvsj_1ybop_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1ybop_879",
  "hide-tools": "awsui_hide-tools_hyvsj_1ybop_889",
  "show-tools": "awsui_show-tools_hyvsj_1ybop_901",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1ybop_879",
  "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_1ybop_977",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_1ybop_993",
  "trigger": "awsui_trigger_hyvsj_1ybop_977",
  "selected": "awsui_selected_hyvsj_1ybop_1045",
  "badge": "awsui_badge_hyvsj_1ybop_1065",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_1ybop_1069",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_1ybop_1080",
  "dot": "awsui_dot_hyvsj_1ybop_1084",
  "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_1ybop_1097"
};
  